export const downloadFile = (data, fileName, extension, type) => {
    const blob = new Blob([data], { type })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.setAttribute('hidden', '')
    a.setAttribute('href', url)
    a.setAttribute('target', '_blank')
    a.setAttribute('download', fileName + '.' + extension)
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
}

